const MAP_LOCALITY = {
  display: {
    en: 'Area su mappa',
    fr: 'Area su mappa',
    de: 'Area su mappa',
    lu: 'Area su mappa',
  },
  geo: {},
  has_children: false,
  hkey: '',
  id: '',
  lat: null,
  level: 999,
  levels: {},
  lon: null,
  name: 'Area su mappa',
  parent: {},
  parents: [],
  postalcode: null,
  slug: '',
  slugs: {},
  type: '',
};

export default MAP_LOCALITY;
